/**
 * Slide-Up CTA Badge - Right Side
 * Shows when user scrolls down, hides at top
 */

(function() {
  'use strict';

  const ctaBadge = document.querySelector('[data-slide-up-cta]');
  if (!ctaBadge) return;

  const SCROLL_THRESHOLD = 200; // Show after 200px scroll
  let ticking = false;

  function updateCTAVisibility() {
    const scrollY = window.scrollY;

    if (scrollY > SCROLL_THRESHOLD) {
      ctaBadge.classList.add('visible');
    } else {
      ctaBadge.classList.remove('visible');
    }

    ticking = false;
  }

  // Throttled scroll listener
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(updateCTAVisibility);
      ticking = true;
    }
  });

  // Initial check
  updateCTAVisibility();

  // Handle CTA badge click - open discount modal
  const ctaBadgeText = ctaBadge.querySelector('[data-cta-badge-click]');
  const discountModal = document.querySelector('[data-discount-modal]');

  if (ctaBadgeText && discountModal) {
    ctaBadgeText.addEventListener('click', function() {
      discountModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }

})();
